export const switchActiveTab = (
  tabId: string | null | undefined,
  validTabs: { id: string }[],
  tabSetter: (id: string) => void,
) => {
  if (tabId && validTabs.some((tab) => tab.id === tabId)) {
    tabSetter(tabId);
  }
};
